import { rest } from "common/api-client/rest";
import apiURL from "common/config/api-url.config";
import type { Result } from "common/utils/result";

export const BFYI_AUTH_TYPE = 1;
export const MSAL_AUTH_TYPE = 2;

type SuccessfulAuthenticationTypeResponse = {
  validation: true;
  authenticationType: typeof MSAL_AUTH_TYPE | typeof BFYI_AUTH_TYPE;
};
type AuthenticationTypeResponse =
  | SuccessfulAuthenticationTypeResponse
  | { validation: false; message?: string };

export async function getAuthenticationType(
  userId: string,
): Promise<Result<AuthenticationTypeResponse>> {
  const result = await rest<AuthenticationTypeResponse>("auth/type", {
    baseURL: apiURL,
    body: { userId },
  });

  if (result instanceof Error) {
    return result;
  }
  if (result.kind === "empty") {
    return new Error("Response does not have a body");
  }

  return result.body;
}
